<!-- 库存统计分析 -->
<template>
    <div class="container">
        <div class="header">
            <img class="width_24 mr-12" src="../../assets/information.png">
            <div>
                <div class="color_ff0000">数据每24小时缓存更新一次，可以通过更新缓存的方式手动更新。</div>
                <div>已零售出库量 = 已经零售出库的数量（总部，代理商和门店零售出库总和）。</div>
                <div>代理商库存量 = 所有代理（经销）商剩余库存的总数。（不含已发给门店的产品）。</div>
                <div>门店库存量 = 所有门店的库存总数。</div>
                <div>总部库存量 = 总部的库存量（不含未入库或已发货出库的产品）。</div>
            </div>
        </div>
        <div class="header_div">
            <Input class="w200 mr-24" type="text" v-model="storePrams.name" placeholder="产品名称模糊搜索"></Input>
            <Button class="theme-bg" icon="ios-search" type="warning" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="name">
                        <div>
                            <div>{{row.name}}</div>
                            <div>{{row.specs}}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="show_product_imgs">
                        <div class="flex-c">
                            <img class="width_60 mt-12 mb-12" v-if="row.show_product_imgs.length > 0" :src="row.show_product_imgs[0]">
 	                        <img class="width_60 mt-12 mb-12" v-else src="../../assets/example1.png">
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
    </div>
</template>

<script>
import { 
    warehouse_all_qrcode,
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
            },
            total: 0,
            columnsTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称及规格", slot: "name", align: "center" },
                { title: "已零售出库量", key: "retail_num", align: "center" },
                { title: "代理商库存量", key: "agent_num", align: "center" },
                { title: "门店库存量", key: "store_num", align: "center" },
                { title: "总部库存量", key: "qrcode_count", align: "center" },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            warehouse_all_qrcode(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch(){
            this.getList();
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 24px;
    padding: 24px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.header_div {
    padding: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_60 {
    width: 60px;
    height: 60px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.color_ff0000 {
    color: #ff0000;
}
</style>